<template>
    <div id="wrapper">
        <side-bar :memuData="view.memuData" :memuConfig="view.memuConfig" :dashboardConfig="view.dashboardConfig"></side-bar>
        <div class="d-flex flex-column" id="content-wrapper">
            <div class="content" id="content">
                <top-bar></top-bar>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from '@/components/layouts/SideBar'
import TopBar from '@/components/layouts/TopBar'

export default {
    name: 'businessInfoLayout',
    components:{
        SideBar,
        TopBar
    },
    data() {
        return {
            view: {
                memuConfig: {
                    link: '/backstage/businessInfo/dashboard',
                    systemName: '永豐網路平台',
                    version: '1.0'
                },
                dashboardConfig: {
                  title: '儀表板',
                  link: '/backstage/businessInfo/dashboard',
                  display: true
                },
                memuData: [
                    {
                      'title': '業務資料', tag: 'data_management', url: '#', icon: 'fas fa-solid fa-file', isShow:false, meta: { permission: ['search'] }, children: [
                        { name: '個人訊息', tag: 'information', url: '/backstage/businessInfo/information', meta: { permission: ['search'] }},
                      ]
                    },
                    // {
                    //   'title': '直推', tag: 'direct_push', url: '#', icon: 'fas fa-solid fa-file-signature', isShow:false, meta: { permission: ['search'] }, children: [
                    //     { name: '直推契約', tag: 'contract', url: '/backstage/businessInfo/contract', meta: { permission: ['search'] }},
                    //     { name: '直推回歸件', tag: 'returnPiece', url: '/backstage/businessInfo/returnPiece', meta: { permission: ['search'] }},
                    //   ]
                    // },
                    {
                      'title': '組織圖表', tag: 'chart', url: '#', icon: 'fa fa-bar-chart', isShow:false, meta: { permission: ['search'] }, children: [
                        { name: '組織樹', tag: 'organizationTree', url: '/backstage/businessInfo/organizationTree', meta: { permission: ['search'] }},
                      ]
                    },
                    // {
                    //   'title': '獎金', tag: 'chart', url: '#', icon: 'fas fa-regular fa-trophy', isShow:false, meta: { permission: ['search'] }, children: [
                    //     { name: '獎金系統', tag: 'organizationTree', url: 'https://www.mutual1319.com.tw/login?log=1&fbclid=IwAR1TZ-dVdRmT3l02HYEc2OHOfHVi9srVNNr-BK_REn6W-FbbFHF0m1t_Xws', meta: { permission: ['search'] }, target: '_blank'},
                    //   ]
                    // },
                ]
            },
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            //側邊欄重整子選單不能關閉
            // let subMenu = JSON.parse(localStorage.getItem('sideBar'));
            // if(subMenu) this.view.memuData = subMenu;
        },
    }
}
</script>

<style lang="scss" scoped>
// Main page wrapper
#wrapper {
  display: flex;
  #content-wrapper {
    background-color: #FFFFFF;
    // width: 100vw;
    flex: 1 1 auto;
    overflow-x: hidden;
    #content {
      flex: 1 0 auto;
      min-height: 100vh;
      @media screen and (max-width: 720px) {
        margin-left: 0vw !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/businessInfo/Layout.vue